import React from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";
import {
  SiNextDotJs,
  SiAdobephotoshop,
  SiTypescript,
  SiJest,
  SiMongodb,
  SiGithub
} from "react-icons/si";

export default function SoftwareSkill() {
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {skillsSection.softwareSkills.map((skills, i) => {
            // let CustomIcon = skills.customIcon;
            return (
              <li
                key={i}
                className="software-skill-inline"
                name={skills.skillName}
              >
                {skills.fontAwesomeClassname && (
                  <i className={skills.fontAwesomeClassname} />
                )}
                {skills.customIcon === "SiNextDotJs" && <SiNextDotJs />}
                {skills.customIcon === "SiAdobephotoshop" && (
                  <SiAdobephotoshop />
                )}
                {skills.customIcon === "SiTypescript" && <SiTypescript />}
                {skills.customIcon === "SiJest" && <SiJest />}
                {skills.customIcon === "SiMongodb" && <SiMongodb />}
                {skills.customIcon === "SiGithub" && <SiGithub />}

                <p>{skills.skillName}</p>
                {/* {skills.customIcon && <CustomIcon />} */}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
